import React, { useRef, useState } from "react";
import Style from "../style/contact.module.scss";

const Contact = () => {
  const defaultMapURL = `https://www.openstreetmap.org/export/embed.html?bbox=72.77,18.87,72.97,19.17&layer=mapnik&marker=19.0760,72.8777`;
  const [mapURL, setMapURL] = useState(defaultMapURL);

  const mapRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLDivElement>(null);

  const handleAddressClick = () => {
    const newMapURL = `https://www.openstreetmap.org/export/embed.html?bbox=77.21,28.61,77.23,28.63&layer=mapnik&marker=28.6139,77.2090`;
    setMapURL(newMapURL);
    mapRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const [data, setData] = useState({
    name: "",
    business_name: "",
    email: "",
    number: "",
    message: "",
  });

  const [error, setError] = useState<Record<string, string>>({});

  const handleScroll = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setData((prev) => ({ ...prev, [id]: value }));

    setError((prev) => ({
      ...prev,
      [`${id}Error`]:
        value.trim() === "" ? `Please enter ${id.replace("_", " ")}` : "",
    }));
  };

  const validate = () => {
    const newError: Record<string, string> = {};
    let isValid = true;

    Object.entries(data).forEach(([key, value]) => {
      if (!value.trim()) {
        newError[`${key}Error`] = `Please enter ${key.replace("_", " ")}`;
        isValid = false;
      }
    });

    if (data.number.length !== 10) {
      newError.numberError = "Please enter a 10-digit number";
      isValid = false;
    }

    setError(newError);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await fetch("http://127.0.0.1:8000/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      alert(result.message);
      setData({
        name: "",
        business_name: "",
        email: "",
        number: "",
        message: "",
      });
    } catch (err) {
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <nav className={Style.link}>
          <a href="/">Home</a>
          <i className="fa-solid fa-angle-right" aria-hidden="true"></i>
          <span aria-current="page">Contact</span>
        </nav>

        <section className={Style.file}>
          <div className={Style.fileText}>
            <h2>
              Get qualified leads from a valuable, <span>ready-to-buy</span>{" "}
              audience.
            </h2>
            <button onClick={handleScroll}>Get Started Today</button>
          </div>
          <div className={Style.fileImage}>
            <img
              src="https://i1.ypcdn.com/ypu/images/marketing-services/hero-image.png?v=3639af0"
              alt="Marketing tools preview"
              loading="lazy"
            />
          </div>
        </section>

        <section className={Style.solution}>
          <div className={Style.solutionImage}>
            <img
              src="https://i1.ypcdn.com/ypu/images/marketing-services/ess-graphic.png?v=3639af0"
              alt="Marketing solutions"
              loading="lazy"
            />
          </div>
          <div className={Style.solutionText}>
            <h2>Extended Search Solutions</h2>
            <h3>
              <span>Promote your business</span> online where customers are
              ready to buy.
            </h3>
            <p>
              Maximize opportunities to be discovered on high-traffic platforms.
              Simple, cost-effective marketing to reach buyers at the right
              time.
            </p>
            <button onClick={handleScroll}>Explore Solutions</button>
          </div>
        </section>

        <section className={Style.Detail}>
          <div className={Style.phone}>
            <i className="fa-solid fa-phone" aria-hidden="true"></i>
            <h2>Phone Number</h2>
            <p>+91-1234567899</p>
          </div>
          <div className={Style.phone}>
            <i className="fa-solid fa-envelope" aria-hidden="true"></i>
            <h2>Email Address</h2>
            <p>company@gmail.com</p>
          </div>
          <div className={Style.phone}>
            <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
            <h2>Address</h2>
            <p
              className={Style.address}
              style={{ cursor: "pointer", color: "blue" }}
              onClick={handleAddressClick}
              role="button"
              tabIndex={0}
            >
              Pocket C, Sidhartha Nagar, New Delhi
            </p>
          </div>
        </section>

        <section className={Style.mainbox} ref={formRef}>
          <div className={Style.title}>
            <h2>Contact Us</h2>
          </div>
          <div className={Style.content}>
            <form onSubmit={handleSubmit} noValidate>
              <div className={Style.formbox}>
                {[
                  { id: "name", type: "text", placeholder: "Name" },
                  {
                    id: "business_name",
                    type: "text",
                    placeholder: "Business Name",
                  },
                ].map(({ id, type, placeholder }) => (
                  <div className={Style.box} key={id}>
                    <input
                      type={type}
                      id={id}
                      placeholder={placeholder}
                      value={data[id as keyof typeof data]}
                      onChange={handleChange}
                    />
                    <span>{error[`${id}Error`]}</span>
                  </div>
                ))}
              </div>
              <div className={Style.formbox}>
                {[
                  { id: "email", type: "email", placeholder: "Email" },
                  { id: "number", type: "text", placeholder: "Phone Number" },
                ].map(({ id, type, placeholder }) => (
                  <div className={Style.box} key={id}>
                    <input
                      type={type}
                      id={id}
                      placeholder={placeholder}
                      value={data[id as keyof typeof data]}
                      onChange={handleChange}
                    />
                    <span>{error[`${id}Error`]}</span>
                  </div>
                ))}
              </div>
              <div className={Style.message}>
                <textarea
                  id="message"
                  placeholder="Write your message here"
                  value={data.message}
                  onChange={handleChange}
                />
                <span>{error.messageError}</span>
              </div>
              <div className={Style.button}>
                <button type="submit">Submit Message</button>
              </div>
            </form>
          </div>
        </section>

        <section className={Style.map} ref={mapRef}>
          <iframe
            width="100%"
            height="400"
            src={mapURL}
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            title="Company location map"
          ></iframe>
        </section>
      </div>
    </div>
  );
};

export default Contact;
